export default [
    {
        path: '/homepage',
        name: 'homepage',
        component: () => import('@/views/Homepage.vue'),
    },
    {
        path: '/error-404',
        name: 'error-404',
        component: () => import('@/views/error/Error404.vue'),
        meta: {
            layout: 'full',
            resource: 'Auth',
            action: 'read',
        },
    },
    {
        path: '/login',
        name: 'auth-login',
        component: () => import('@/views/pages/authentication/Login.vue'),
        meta: {
            layout: 'full',
            resource: 'Auth',
            redirectIfLoggedIn: true,
        },
    },
    {
        path: '/login/select-organization',
        name: 'select-organization',
        component: () => import('@/views/pages/authentication/SelectOrganization.vue'),
        meta: {
            layout: 'full',
            resource: 'Auth',
            redirectIfLoggedIn: true,
        },
    },
    {
        path: '/register',
        name: 'auth-register',
        component: () => import('@/views/pages/authentication/Register.vue'),
        meta: {
            layout: 'full',
            resource: 'Auth',
            redirectIfLoggedIn: true,
        },
    },
    {
        path: '/swift-login',
        name: 'swift-login',
        component: () => import('@/views/pages/authentication/SwiftLogin.vue'),
        meta: {
            layout: 'full',
            resource: 'Auth',
        },
    },
    {
        path: '/login/mfa/select',
        name: 'mfa-method-select',
        component: () => import('@/views/pages/authentication/MfaMethodSelector.vue'),
        meta: {
            layout: 'full',
            resource: 'Auth',
            redirectIfLoggedIn: true,
        },
    },
    {
        path: '/login/mfa/email',
        name: 'mfa-email',
        component: () => import('@/views/pages/authentication/MfaEmailAuthentication.vue'),
        props: {
            autoSend: true,
        },
        meta: {
            layout: 'full',
            resource: 'Auth',
            redirectIfLoggedIn: true,
        },
    },
    {
        path: '/login/mfa/sms',
        name: 'mfa-sms',
        component: () => import('@/views/pages/authentication/MfaSmsAuthentication.vue'),
        props: {
            autoSend: true,
        },
        meta: {
            layout: 'full',
            resource: 'Auth',
            redirectIfLoggedIn: true,
        },
    },
    {
        path: '/forgot-password',
        name: 'auth-forgot-password',
        component: () => import('@/views/pages/authentication/ForgotPassword.vue'),
        meta: {
            layout: 'full',
            resource: 'Auth',
            redirectIfLoggedIn: true,
        },
    },
    {
        path: '/reset-password',
        name: 'auth-reset-password',
        component: () => import('@/views/pages/authentication/ResetPassword.vue'),
        meta: {
            layout: 'full',
        },
    },
    {
        path: '/not-authorized',
        name: 'not-authorized',
        component: () => import('@/views/pages/miscellaneous/NotAuthorized.vue'),
        meta: {
            layout: 'full',
            resource: 'Auth',
        },
    },
]
